import type { ValueGetterParams } from 'ag-grid-community';
import { get } from 'lodash-es';
import { type DateOnly, formatFixingTimeAtDateOnly } from '../../../utils';
import { baseColumn } from './baseColumn';
import type { ColDefFactory, Column } from './types';

export interface FixingIndexTimeAtDateColumnParams {
  /** Required field for where to get the DateOnly that we should render this time for, for example a FixingDate. */
  dateOnlyField?: string;
}

/** Given a FixingIndex.Name, will render the fixing time for this index at a specific Date */
export const fixingIndexTimeAtDate: ColDefFactory<Column<FixingIndexTimeAtDateColumnParams>> = column => ({
  ...baseColumn(column),
  // We do all the work here in the valueGetter because it does not make sense for this data type to return the fixing index obj or similar
  valueGetter: (params: ValueGetterParams<unknown>): string | undefined => {
    if (!column.field || !params.data) {
      return undefined;
    }

    const fixingIndexName = get(params.data, column.field);
    const fixingIndex = fixingIndexName ? params.context.current.fixingIndicesByName?.get(fixingIndexName) : undefined;
    if (!fixingIndex) {
      return undefined;
    }

    const dateOnly: DateOnly | undefined = column.params?.dateOnlyField
      ? get(params.data, column.params.dateOnlyField)
      : undefined;

    if (dateOnly == null || dateOnly === '') {
      return undefined;
    }

    return formatFixingTimeAtDateOnly(fixingIndex, dateOnly);
  },
});
